import { render, staticRenderFns } from "./StallAdd.vue?vue&type=template&id=5a82cee0&scoped=true"
import script from "./StallAdd.vue?vue&type=script&lang=js"
export * from "./StallAdd.vue?vue&type=script&lang=js"
import style0 from "./StallAdd.vue?vue&type=style&index=0&id=5a82cee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a82cee0",
  null
  
)

export default component.exports